import { render, staticRenderFns } from "./ConfigurationWidget.vue?vue&type=template&id=0c6bff70&scoped=true&"
import script from "./ConfigurationWidget.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWidget.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWidget.vue?vue&type=style&index=0&id=0c6bff70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6bff70",
  null
  
)

export default component.exports